/* eslint-disable no-param-reassign */

import { queryStrategy } from '../data/strategies';

const informationParameters = [
    { name: 'productReference', key: 'product_reference' },
    { name: 'productTitle', key: 'product_title', prompt: true },
    { name: 'productUrl', key: 'product_url', prompt: true },
];

export function makeProject ({
    api, playerFrontUrl, playerEmbedUrl, onUpload,
}) {
    return {
        namespaced: true,
        state: {
            projects: [],
            uploadInformation: {},
        },
        getters: {
            getPlayerFrontURL () {
                return (id) => `${playerFrontUrl}?v=${id}`;
            },
            getPlayerEmbedURL () {
                return (id) => `${playerEmbedUrl}#id=${id}`;
            },
            shouldAskInformation (state) {
                return informationParameters.some(({ name, prompt = false }) => prompt && !state.uploadInformation[name]);
            },
            validatedProjects (state) {
                return state.projects.filter((project) => project.status === 'VALIDATED');
            },
        },
        mutations: {
            SET_PROJECTS (state, projects) {
                state.projects = projects;
            },
            SET_INFORMATION (state, uploadInformation) {
                state.uploadInformation = uploadInformation;
                console.log('[Project] Upload information: ', { ...uploadInformation });
            },
        },
        actions: {
            /**
             * Upload files: destination will be either a new project,
             * or an existing pending one.
             */
            async uploadFiles ({ state, rootState, dispatch }, { files, productId }) {
                let project = state.projects.find(({ status }) => ['PENDING', 'PENDING_RUSHES'].includes(status));
                const inputs = files.map((file) => ({
                    title: file.fileName,
                    url: file.url,
                }));

                if (project) {
                    project = await api.addProjectInputs({
                        projectId: project.id,
                        inputs,
                    });
                } else {
                    let newProject = {
                        solutionId: rootState.solution.id,
                        userId: rootState.user.user.id,
                        inputs,
                        uploadInformation: state.uploadInformation,
                    };
                    if (rootState.orders && productId) {
                        try {
                            const order = rootState.orders.find((o) => o.product.id === productId);
                            if (order) {
                                newProject = {
                                    ...newProject,
                                    orderId: Buffer.from(order.id, 'base64').toString('ascii').split(':')[1],
                                };
                            }
                        } catch (err) {
                            console.error(err);
                        }
                    }
                    project = await api.createProject(newProject);
                }

                // Refetch projects for the next uploads
                await dispatch('updateProjects');

                onUpload(project);
            },
            async updateProjects ({ rootState, commit }) {
                const projects = await api.getProjects(rootState.solution.id, rootState.user.user);
                commit('SET_PROJECTS', projects);
            },
            /**
             * Auto-fills upload information from URL query parameters
             */
            async updateUploadInformation ({ commit }) {
                const uploadInformation = informationParameters.reduce((acc, { name, key }) => ({
                    ...acc,
                    [name]: queryStrategy(key),
                }), {});
                commit('SET_INFORMATION', uploadInformation);
            },
            /**
             * Adds partial information to upload information
             */
            addUploadInformation ({ state, commit }, uploadInformation) {
                commit('SET_INFORMATION', {
                    ...state.uploadInformation,
                    ...uploadInformation,
                });
            },
        },
    };
}
